import initAccount from '@sectionsJS/account';

$(async () => {
  initAccount();
});
